import SimpleTableHelpDialog from "./commons/SimpleTableHelpDialog";

export default function ODI3HelpDialog() {
  return (
    <SimpleTableHelpDialog
      title="ODI3の説明"
      explain={{
        title: "ODI3とは",
        content:
          "睡眠時無呼吸症候群の簡易スクリーニング検査の指標で、酸素飽和度がベースラインから3%以上下がった回数/時間を示します。\n睡眠中に呼吸が止まると酸素飽和度が下がるため、その回数が多ければ多いほど睡眠時無呼吸症候群の疑いが強くなります。\nSLEEP COMPASSではODI3が5以上の場合に「リスクあり」として表示しています。",
      }}
      table={{
        title: "ODI3の重症度",
        records: [
          ["ODI3の値", "重症度"],
          ["1未満", "睡眠呼吸障害のリスクは非常に低いです"],
          ["1 ≦ ODI3 ＜ 5", "睡眠呼吸障害のリスクは低いです"],
          ["5 ≦ ODI3 ＜ 15", "睡眠呼吸障害のリスクが中程度です"],
          ["15 ≦ ODI3 ＜ 30", "睡眠呼吸障害のリスクが高いです"],
          ["ODI3 30以上", "睡眠呼吸障害のリスクが非常に高いです"],
        ],
      }}
      reference="2023 年改訂版 循環器領域における睡眠呼吸障害の診断・治療に関するガイドライン"
    />
  );
}
